import Cloudprinter from '../services/CloudprinterService'

export default {
  data () {
    return {
      orderData: {}
    }
  },

  created () {
    this.orderData = this.$store.getters['cpOrder/allData']
  },

  methods: {
    getCountryList: function () {
      return Cloudprinter.getCountries().then((response) => {
        this.orderData.cpCountries = response.data.shipping_countries
      })
    },

    getStates: function () {
      if (this.stateIsRequired()) {
        const selectedCountry = this.orderData.shipping_address.country

        Cloudprinter.getStates(selectedCountry).then((response) => {
          this.orderData.cpStates = response.data.shipping_states
        })
      }
    },

    stateIsRequired: function () {
      const selectedCountry = this.orderData.shipping_address.country

      for (let country of this.orderData.cpCountries) {
        if (country.country_reference === selectedCountry && country.require_state === 1) {
          this.orderData.stateIsRequired = true
          return true
        }
      }
      this.orderData.shipping_address.state = ''

      this.orderData.stateIsRequired = false

      return false
    },

    zipIsRequired: function (countryCode) {
      let notRequiredZip = ['AE', 'AG', 'AO', 'AW', 'BF', 'BI', 'BJ', 'BM', 'BO', 'BQ', 'BS', 'BW', 'BZ', 'CD', 'CF', 'CG', 'CI', 'CK', 'CM', 'CW', 'DJ', 'DM', 'ER', 'FJ', 'GA', 'GD', 'GH', 'GM', 'GQ', 'GY', 'HK', 'HM', 'IE', 'KI', 'KM', 'KN', 'KP', 'LY', 'ML', 'MO', 'MR', 'MW', 'NA', 'NL', 'NR', 'NU', 'PE', 'QA', 'RW', 'SB', 'SC', 'SL', 'SR', 'ST', 'SX', 'SY', 'TD', 'TF', 'TG', 'TK', 'TL', 'TO', 'TT', 'TV', 'UG', 'VU']

      return notRequiredZip.indexOf(countryCode) === -1
    }
  }
}
